import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import 'swiper/css';
import 'swiper/css/pagination';
import './Arrivals.css';

const Arrivals = () => {
  const [heartStates, setHeartStates] = useState([false, false, false, false, false, false]);

  const toggleHeart = (index) => {
    setHeartStates((prevStates) => {
      const updatedStates = [...prevStates];
      updatedStates[index] = !updatedStates[index];
      return updatedStates;
    });
  };

  const cards = [
    { id: 1, backgroundImage: "url('images/flower-1.png')" },
    { id: 2, backgroundImage: "url('images/flower-2.png')" },
    { id: 3, backgroundImage: "url('images/flower-3.png')" },
    { id: 4, backgroundImage: "url('images/flower-4.png')" },
    { id: 5, backgroundImage: "url('images/flower-1.png')" },
    { id: 6, backgroundImage: "url('images/flower-2.png')" },
  ];

  return (
    <div className="mt-5 container-fluid">
      <div className="d-flex gap-2 justify-content-between align-items-center px-3 mb-4">
        <img src="images/Group 76.png" className="category-title" alt="" />
      </div>
      <Swiper
        className="px-5 pb-5"
        modules={[Pagination]}
        pagination={{ clickable: true, el: '.custom-pagination' }}
        spaceBetween={70}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 4 },
        }}
        loop
      >
        {cards.map((card, index) => (
          <SwiperSlide key={card.id}>
            <div
              className="card rounded-5 h-100 position-relative"
              style={{
                backgroundImage: card.backgroundImage,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top',
                paddingTop: '190px',
              }}
            >
              {heartStates[index] ? (
                <FontAwesomeIcon
                  icon={faHeart}
                  className="text-danger arrivals-heart-icon position-absolute"
                  onClick={() => toggleHeart(index)}
                />
              ) : (
                <img
                  src="images/heart-thin.png"
                  className="arrivals-heart-image position-absolute"
                  alt=""
                  onClick={() => toggleHeart(index)}
                />
              )}
              <div className="p-3 desc-container rounded-5">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h3 className="mb-3">Lorem ipsum</h3>
                </div>
                <p className="mb-4">Lorem Ipsum is simply dummy</p>
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <h6 className="text-white price-bg px-2 py-1 m-0 rounded-pill">$100</h6>
                  <img src="images/bi_cart.svg" className="hovers" alt="" />
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="custom-pagination"></div>
    </div>
  );
};

export default Arrivals;
